/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('store.variantSelectionReplaceHTML', function (e) {
        var selectedVariant = e.variantSelection.getSelectedVariant();
        if (!selectedVariant) {
            return;
        }
        updateStockStatus();
        updateAttrValues();
        function updateStockStatus() {
            var currentStockStatus = selectedVariant.el.dataset.stockStatus;
            if (!currentStockStatus) {
                return;
            }
            var stockStatusTemplate = document.createElement('div');
            stockStatusTemplate.innerHTML = currentStockStatus;
            var stockStatusEl = document.querySelector('#variant-stock-status');
            stockStatusEl.innerHTML = stockStatusTemplate.firstElementChild.innerHTML;
        }
        function updateAttrValues() {
            var attrValueSizeEl = document.querySelector('.attributesValues [data-aid="246"] .av-value');
            var currAttrValueSizeEl = selectedVariant.el.querySelector('.attribute[data-aid="246"] .value');
            if (!attrValueSizeEl || !currAttrValueSizeEl) {
                return;
            }
            attrValueSizeEl.innerHTML = currAttrValueSizeEl.innerHTML;
        }
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
